import moment from 'moment';

export interface EmailSchedulerType {
  schedulerStartDate: Date | null;
  schedulerEndDate: Date | null;
  scheduledDate: Date | null;
  scheduledTime: Date | null;
  scheduledDay: string;
  toEmails: string[];
}

export interface EmailSchedulerErrorType {
  schedulerStartDate: boolean;
  schedulerEndDate: boolean;
  scheduledDate: boolean;
  scheduledTime: boolean;
  toEmails: boolean;
}

export const emailSchedulerDefaultObject: EmailSchedulerType = {
  schedulerStartDate: null,
  schedulerEndDate: null,
  scheduledDate: null,
  scheduledTime: null,
  scheduledDay: '',
  toEmails: [],
};
export const emailSchedulerErrorDefaultObject: EmailSchedulerErrorType = {
  schedulerStartDate: false,
  schedulerEndDate: false,
  scheduledDate: false,
  scheduledTime: false,
  toEmails: false,
};

export const getDayDropdownOptions = (noOfDays: number) => {
  const dropdownOptions = [
    '1st',
    '2nd',
    '3rd',
    '4th',
    '5th',
    '6th',
    '7th',
    '8th',
    '9th',
    '10th',
    '11th',
    '12th',
    '13th',
    '14th',
    '15th',
    '16th',
    '17th',
    '18th',
    '19th',
    '20th',
    '21st',
    '22nd',
    '23rd',
    '24th',
    '25th',
    '26th',
    '27th',
    '28th',
    '29th',
    '30th',
    '31st',
  ];

  return dropdownOptions?.slice(0, noOfDays);
};

export const getDayDropdownValues = (noOfDays: number) => {
  const dropdownValues = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
  ];

  return dropdownValues?.slice(0, noOfDays);
};

export const formatEmailSchedulerData = (
  emailSchedulerDTO: any,
): EmailSchedulerType => {
  const months: { [key: string]: number } = {
    Jan: 0,
    Feb: 1,
    Mar: 2,
    Apr: 3,
    May: 4,
    Jun: 5,
    Jul: 6,
    Aug: 7,
    Sep: 8,
    Oct: 9,
    Nov: 10,
    Dec: 11,
  };

  if (emailSchedulerDTO) {
    const {
      schedulerStartMonth,
      schedulerStartYear,
      schedulerEndMonth,
      schedulerEndYear,
      scheduledYear,
      scheduledMonth,
      scheduledDate,
      scheduledTime,
      toEmails,
    } = emailSchedulerDTO;

    const schedulerStartDate = new Date(
      schedulerStartYear,
      months[schedulerStartMonth],
      1,
    );
    const schedulerEndDate = new Date(
      schedulerEndYear,
      months[schedulerEndMonth],
      1,
    );
    const convertedScheduledDate = new Date(
      scheduledYear,
      months[scheduledMonth],
      parseInt(scheduledDate),
      parseInt(scheduledTime.split(':')[0]),
      parseInt(scheduledTime.split(':')[1]),
    );

    const emailSchedulerData: EmailSchedulerType = {
      schedulerStartDate,
      schedulerEndDate,
      scheduledDate: convertedScheduledDate,
      scheduledTime: convertedScheduledDate,
      scheduledDay: scheduledDate,
      toEmails: toEmails,
    };

    return emailSchedulerData;
  } else {
    return emailSchedulerDefaultObject;
  }
};

export const isValidDate = (date: Date | null): boolean => {
  return date instanceof Date && !isNaN(date.getTime());
};

export const getEmailSchedulerRequestBody = (
  scheduledDate: Date | null,
  scheduledDay: string,
  scheduledTime: Date | null,
  schedulerStartDate: Date | null,
  schedulerEndDate: Date | null,
  toEmails: string[],
  schedulerEmail: string,
  downloadFrequency: string,
) => {
  const emailSchedulerRequestBody = {
    schedulerEmail,
    schedulerStartMonth: isValidDate(schedulerStartDate)
      ? moment(schedulerStartDate).format('MMM')
      : null,
    schedulerStartYear: isValidDate(schedulerStartDate)
      ? moment(schedulerStartDate).format('YYYY')
      : null,
    schedulerEndMonth: isValidDate(schedulerEndDate)
      ? moment(schedulerEndDate).format('MMM')
      : null,
    schedulerEndYear: isValidDate(schedulerEndDate)
      ? moment(schedulerEndDate).format('YYYY')
      : null,
    scheduledYear:
      downloadFrequency === 'Custom' && isValidDate(scheduledDate)
        ? moment(scheduledDate).format('YYYY')
        : isValidDate(schedulerStartDate)
        ? moment(schedulerStartDate).format('YYYY')
        : null,
    scheduledMonth:
      downloadFrequency === 'Custom' && isValidDate(scheduledDate)
        ? moment(scheduledDate).format('MMM')
        : isValidDate(schedulerStartDate)
        ? moment(schedulerStartDate).format('MMM')
        : null,
    scheduledDate: scheduledDay,
    scheduledTime: isValidDate(scheduledTime)
      ? `${moment(scheduledTime).format('HH:mm')},${
          Intl.DateTimeFormat().resolvedOptions().timeZone
        }`
      : null,
    toEmails,
  };

  return emailSchedulerRequestBody;
};
